// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"351f998d","546":"aada4f31","781":"aada4f31","804":"a287b834","943":"aebeccb9"}[chunkId] + ".chunk.css";
};